import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom'
// import './Cover.css'
import Background from './background.jpeg';
import Logo from './banner.jpg';
import ReactLoading from "react-loading";
import * as Session from './session'
import { addSurveyToFireStore } from './Config/config';
import ReactGA from 'react-ga';

export class Register extends Component {
  
  constructor(props) {
    super(props)
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.state = {
      ...Session.currentSession,
      __isSaving: false,
      __savingErrorOccurred: false
    }
  }

  handleSurveySave(){
    this.setState({__isSaving: true, __savingErrorOccurred: false},
      () => {
        Session.login().then( logInData => {
          Session.setSessionAnynomousUser(logInData.user);
          return addSurveyToFireStore(Session.currentSession.contactEmail, Session.currentSession)
        })    
        .then(response => {
          this.setState({__isSaving: false})
          this.props.history.push(Session.startSubSectionUrl())
        })
        .catch(error => {
          console.log("Got an error: ", error);
          this.setState({__savingErrorOccurred: true})
        })
    })
  }

  tryStarting(){
    if (Session.isReadyToStart()) {
      this.handleSurveySave()
    } else {
      alert('Por favor preencha os dados em falta')
    }
  }

  onSessionChange(key, event){
    let value = event.target.value
    Session.set(key, value)
    this.setState({
      validSector: Session.isValidSector(Session.currentSession.sectorId),
      validCompany: Session.isValidCompanyId(Session.currentSession.companyId),
      validEmail: Session.isValidEmail(Session.currentSession.contactEmail)
    })
    console.log(Session.currentSession)
  }

  render() {
    if (this.state.__isSaving) {
      return (
        <div className="h-100">
            <div className="text-center">
                <br/>
                <br/>
                <span>A iniciar ...</span>
                <br/>
                <br/>
                <ReactLoading type="spin" color="blue" className="mx-auto"/>
                <br/>
                <br/>
                <div className="">
                  <p className="text-info small">
                    Irá receber um <b>email</b> com um link para o seu teste  
                  </p>
                  <p className="text-info small">
                    Pode usar o link se quiser retomar o preenchimento do teste  
                  </p>
                </div>
            </div>
        </div>
      )
    } else {
      return (
      <div className="remove-cover-wrapper text-center h-100">
        <div className="remove-cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
          <div className="inner remove-cover">
            <p>
              <br/>
            </p>
            <p className="text-secondary">
              Antes de iniciar, por favor preencha a informação abaixo
            </p>
            <p className="lead">
              <select className="form-control form-control-lg w-50 mx-auto text-center" onChange={this.onSessionChange.bind(this, 'sectorId')}  style={ {  borderColor: (this.state.validSector === false? 'red' : 'green') }} value={this.state.sectorId}>
                <option value="">Seleccione Sector</option>
                <option value="agro">AgroIndustrial</option>
                <option value="metal">Metalomecânica</option>
                <option value="transports">Transportes e Logística</option>
                <option value="waste">Ambiente e Resíduos</option>
              </select>
            </p>
            <p className="lead">
              <input 
                  className="form-control form-control-lg w-50 mx-auto text-center"
                  type="text"
                  placeholder="Nome Empresa ou NIF" 
                  style={ {  color: (this.state.validCompany === false? 'red' : 'green') }}
                  value={this.state.companyId}
                  onChange={this.onSessionChange.bind(this, 'companyId')}
                  />
            </p>
            <p className="lead">
              <input 
                className="form-control form-control-lg w-50 mx-auto text-center"
                type="email"
                placeholder="email@empresa.pt" 
                style={ {  color: (this.state.validEmail === false? 'red' : 'green') }}
                value={this.state.contactEmail}
                onChange={this.onSessionChange.bind(this, 'contactEmail')}
                />
            </p>
            <p>
              <br/>
            </p>
            <p className="text-secondary small">
              Completar o diagnóstico demora 15-20 minutos.  
            </p>
            <p className="remove-lead">
              <button className="btn btn-lg btn-primary" onClick={this.tryStarting.bind(this)}>
                Iniciar
              </button>
            </p>
          </div>

          <footer className="mastfoot mt-auto">
            <div className="inner">
            </div>
          </footer>
        </div>
    </div>
    ) 
    }
  }
}





// WEBPACK FOOTER //
// ./src/Register.jsx